var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-sidebar-small-group"},[_c('invite-letter'),_c('filter-card',{attrs:{"page":"myCourse"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }